export default __webpack_public_path__ + "static/media/css.7f2b927e.svg";